import React, { useCallback, useEffect, useMemo } from 'react';
import { IRelationalOperatorFieldsFragment } from '../../../../../../utils/apollo/graphqlSchema';
import { setCohortRowReturnedOperator } from '../../../../../../redux/slices/oldBuilder';
import { useAppDispatch } from '../../../../../../redux/hooks';
import { SingleSelectMenu } from '../../../../../Dropdown';
import { useCohortRowContext } from '../../CohortRowContext';

interface IProps {
  returnedOperators: IRelationalOperatorFieldsFragment[];
}

const RetentionCohortReturnedOperators = ({ returnedOperators }: IProps) => {
  const dispatch = useAppDispatch();
  const { rowMeta, cohortRow } = useCohortRowContext();
  const { returnedOperator } = cohortRow;

  const handleChange = useCallback(
    (newOperator: string) => {
      dispatch(
        setCohortRowReturnedOperator({
          value: newOperator,
          rowMeta,
        }),
      );
    },
    [dispatch, rowMeta],
  );

  const options = useMemo(
    () =>
      returnedOperators.map((item) => ({
        text: item.name,
        value: item.key,
      })),
    [returnedOperators],
  );

  // Set default value on mount
  useEffect(() => {
    if (!returnedOperator) {
      handleChange(returnedOperators[0].key);
    }
  }, [handleChange, returnedOperator, returnedOperators]);

  return (
    <SingleSelectMenu
      options={options}
      value={returnedOperator}
      onChange={handleChange}
    />
  );
};

export default RetentionCohortReturnedOperators;
